export const introAnimationSetup = (gsap, ScrollTrigger) => {
    return window.addEventListener('DOMContentLoaded', function () {
        console.debug('Intro script loaded');
        gsap.registerPlugin(ScrollTrigger);
        const mainIntro = document.querySelector('.spv-campaignPage__mainIntro');
        const videoContainer = document.querySelector('.spv-campaignPage__videoContainer');
        const videoContainter = document.querySelector('.spv-campaignPage__video');
        const video = document.querySelector('.spv-campaignPage__video > video');
        const secondaryIntro = document.querySelector('.spv-campaignPage__secondaryIntro');
        const ticketContainer = document.querySelector('.spv-campaignPage__ticket');
        const scrollyTellItems = mainIntro?.querySelectorAll('.spv-campaignPage__scrollytellItemBlock-container');
        const mm = gsap.matchMedia();
        mm.add('(min-width: 768px)', () => {
            if (scrollyTellItems && scrollyTellItems.length) {
                scrollyTellItems.forEach((item, index) => {
                    const speed = 0.2 + index * 2;
                    ScrollTrigger.create({
                        trigger: mainIntro,
                        start: 'top top',
                        end: 'bottom top-=100',
                        scrub: true,
                        animation: gsap.to(item, {
                            y: `-${30 * speed}%`,
                            ease: 'none',
                            duration: 1,
                        }),
                    });
                });
            }
        });
        ticketContainer?.addEventListener('click', () => {
            if (!secondaryIntro)
                return;
            return window.scrollTo({
                top: secondaryIntro.getBoundingClientRect().top + window.scrollY - 100,
                behavior: 'smooth',
            });
        });
        ScrollTrigger.create({
            trigger: mainIntro,
            start: 'top top',
            end: 'bottom bottom+=1000',
            pinSpacing: false,
            scrub: 1,
            animation: gsap.to(videoContainter, {
                width: '105%',
                height: '105%',
                ease: 'none',
            }),
        });
        ScrollTrigger.create({
            trigger: secondaryIntro,
            start: 'top top',
            end: 'bottom top-=1000',
            pinSpacing: false,
            scrub: 1,
            animation: gsap.to(video, {
                opacity: 1,
            }),
        });
        ScrollTrigger.create({
            trigger: ticketContainer,
            start: 'top center',
            end: 'bottom center+=500',
            scrub: 1,
            animation: gsap.to(ticketContainer, {
                opacity: 0,
            }),
        });
        ScrollTrigger.create({
            trigger: '.spv-campaignPage__filler2',
            start: 'top center+=200',
            end: 'top top',
            scrub: true,
            animation: gsap.to(videoContainer, {
                top: '-100%',
                ease: 'none',
            }),
        });
    });
};
//# sourceMappingURL=intro.js.map